export const isServer = import.meta.server
export const spritePaths = Object.freeze({
  "default": "/_nuxt/nuxt-svg-icon-sprite/sprite-default.onqkhBdMVPjesSH2jEfxSfBNw-W9aLhVw7uQkcx_-RY.svg"
});
export const runtimeOptions = Object.freeze({
  "ariaHidden": false
});
export const allSymbolNames = Object.freeze([
  "area-pin",
  "arrow",
  "breaking-news",
  "broken-flasks",
  "calendar",
  "cart",
  "check",
  "checklist",
  "chevron",
  "city",
  "clock",
  "close",
  "delete",
  "document",
  "download",
  "email",
  "emergency",
  "external",
  "facebook",
  "filter",
  "finder",
  "image-enlarge",
  "individual_member",
  "info",
  "instagram",
  "linkedin",
  "locator",
  "lock",
  "mail-secure",
  "marker-outline",
  "needle",
  "pdf",
  "pharmasuisse",
  "pharmasuisse-filled",
  "phone",
  "pin",
  "play",
  "question",
  "search",
  "special-info",
  "tiktok",
  "twitter",
  "unlocked",
  "youtube"
]);